<template>
  <v-card>
    <v-toolbar flat color="primary" dark>
      <v-toolbar-title>Rates Settings</v-toolbar-title>
    </v-toolbar>
    <v-tabs vertical>
      <v-tab>
        <v-icon left>mdi-settings-box</v-icon>
        Pilotage Charges
      </v-tab>
      <v-tab>
        <v-icon left>mdi-settings-box</v-icon>
        Berthing Party Charges
      </v-tab>

      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <v-tabs background-color="white" color="deep-purple accent-4" left>
                <v-tab>Configured Rates</v-tab>
                <v-tab>Rates Setup</v-tab>
                <v-tab-item >
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12" md="4">
                        No Table Available
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>

                <v-tab-item >
                  <v-container fluid>
                    <v-row no-gutters>       
                      <template>
                        <v-col>
                          <v-card class="pa-2" outlined tile>
                            <pilotage />
                          </v-card>
                        </v-col>
                        <v-col>
                          <v-card class="pa-2" outlined tile>
                            <detentions />
                          </v-card>
                        </v-col>
                        <v-col>
                          <v-card class="pa-2" outlined tile>
                            <over-time-charges />
                          </v-card>
                        </v-col>
                      </template>
                    </v-row>
                  </v-container>
                </v-tab-item>
            </v-tabs>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <p class="mb-0">
              No Data Recorded
            </p>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import Pilotage from '@/components/PilotageDueDataTable'
import Detentions from '@/components/DetentionChargesDataTable'
import OverTimeCharges from '@/components/OverTimeChargesDataTable'
export default {
    name: 'PnCSettings',
    components: {
        Pilotage,
        Detentions,
        OverTimeCharges
    }
}
</script>